import React, { useState } from "react";

// APP COMPONENTS
import { customerBlacklisted } from "../../common/frames";

// MATERIAL UI COMPONENTS
import {
  AutocompleteStyledPaper,
  AutocompleteStyledPopper,
  StyledAutocomplete,
} from "../styled/inputs/autocomplete";
import { StyledTextField } from "../styled/inputs/textInput";

const BlacklistedFilter = ({ selectedValue, onFilterChange }) => {
  const [types, setTypes] = useState(customerBlacklisted);

  return (
    <StyledAutocomplete
      disablePortal={false}
      id="is-blacklisted-options-values"
      options={types}
      getOptionLabel={(option) => option.label}
      groupBy={(option) => option.firstLetter}
      renderInput={(params) => (
        <StyledTextField
          {...params}
          label="Não Confiáveis?"
          variant="outlined"
          InputProps={{
            ...params.InputProps,
          }}
        />
      )}
      PopperComponent={(props) => <AutocompleteStyledPopper {...props} />}
      PaperComponent={(props) => <AutocompleteStyledPaper {...props} />}
      onChange={(event, values) => {
        onFilterChange(values);
      }}
      sx={{ mb: 1 }}
    />
  );
};

BlacklistedFilter.displayName = "NCM";

export default BlacklistedFilter;
